import { buildFetchOptionsWithAuth, fetchJson } from '@fv/client-core'

import { apiUri } from '@/constants'

export async function shipperFetch<T>(
  path: string,
  options?: {
    query?: Record<string, any> | string
    body?: Record<string, any>
    method?: 'GET' | 'PUT' | 'POST' | 'DELETE' | 'PATCH'
  } & Pick<RequestInit, 'signal'>,
): Promise<T> {
  const endpoint = `${apiUri}${path}`
  const response = await fetchJson(
    endpoint,
    buildFetchOptionsWithAuth({
      method: 'GET',
      ...options,
      ...(options?.body && { body: JSON.stringify(options.body) }),
    }),
  )
  if (response.ok) return response.json
  throw response.errorMessage
}

export const shipperFetchFormData = async <T>(
  uri: string,
  options?: Omit<RequestInit, 'body'> & {
    body: FormData
  },
): Promise<T> => {
  const opts = {
    ...buildFetchOptionsWithAuth(),
    ...options,
  }
  delete opts.headers['Content-type']
  const response = await fetch(`${apiUri}${uri}`, opts)
  if (response.ok) return await response.json()
  throw response.body
}

export async function shipperFetchRaw(uri: string, options?: RequestInit) {
  const opts = {
    ...buildFetchOptionsWithAuth(),
    ...options,
  }

  return fetch(`${apiUri}${uri}`, opts)
}
